<template>
    <div class="step-fields-list-box booking-details grey-background">
        <h5 class="step-field-heading step-field-heading-text">Booking Details</h5>
        <div class="row">
            <div v-if="hasService" :class="firstColumnClass">
                <service-row
                :item="details.service"
                :teamMember="details.teamMember"
                :allowSelect="false"></service-row>
            </div>
            <div v-if="hasEvent" :class="firstColumnClass">
                <event-row
                :item="details.event"
                :teamMember="details.teamMember"
                :allowSelect="false"></event-row>
            </div>
            <div v-if="hasSecondColumn" :class="secondColumnClass">
                <ul class="list-unstyled">
                    <li v-if="hasTeamMember" class="list-user">
                        <img src="../../assets/person-24px.svg" class="icon">
                        {{details.teamMember.firstName}} {{details.teamMember.lastName}}
                    </li>
                    <li class="list-clock" v-if="hasSchedulingDateAndTime">
                        <img src="../../assets/access_time-24px.svg" class="icon">
                        {{details.schedulingDateAndTime.startDateTime | toDateString}}
                    </li>
                    <li v-if="hasLocation" class="list-location">
                        <ul class="list-unstyled">
                            <li v-if="locationName" class="list-map-pin">
                            <img src="../../assets/place-24px.svg" class="icon">
                            <strong>{{locationName}}</strong></li>
                            <li :class="addressSecondLine">
                                <div>{{address}}</div>
                                <div v-if="room">{{room}}</div>
                            </li>
                            <li v-if="address">
                                <a :href="directionsHref">Get directions</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import ServiceRow from '../fields/ServiceRow';
  import EventRow from '../fields/EventRow';
  import moment from 'moment';

  export default {
    props: {
      details: {},
    },
    computed: {
        ...mapState('form', { form: 'form'}),
        ...mapGetters('scheduling', [
          'eventLocation'
        ]),
        directionsHref() {
            return 'https://www.google.com/maps/dir/?api=1&destination='+this.address;
        },
        hasService() {
            return Object.keys(this.details.service).length >0;
        },
        hasEvent() {
            return Object.keys(this.details.event).length >0;
        },
        hasLocation() {
            return (
                Object.keys(this.details.location).length > 0
                &&
                this.details.location.id !== 0
            )
            || this.eventLocation;
        },
        hasSchedulingDateAndTime() {
            return Object.keys(this.details.schedulingDateAndTime).length > 0;
        },
        hasTeamMember() {
            return Object.keys(this.details.teamMember).length > 0;
        },
        hasSecondColumn() {
            return this.hasLocation
                || this.hasSchedulingDateAndTime
                || this.hasTeamMember;
        },
        firstColumnClass() {
            return {
                'booking-details-left':true,
                'col': true,
                'col-lg-7': this.hasSecondColumn,
                'col-lg-12': !this.hasSecondColumn,
            }
        },
        secondColumnClass() {
            return {
                'booking-details-right':true,
                'col': true,
                'col-lg-12': !this.hasService && !this.hasEvent,
                'col-lg-5': this.hasService || this.hasEvent,
                'border-left': this.hasService || this.hasEvent
            };
        },
        addressSecondLine() {
            return {
                'list-map-pin': !this.locationName
            };
        },
        locationName() {
            if (this.eventLocation && this.eventLocation.name) {
                return this.eventLocation.name;
            } else if (this.eventLocation && !this.eventLocation.name
                && this.details.location.id === 0) {
                return '';
            } else if (this.details.location.id === 0) {
                return '';
            } else {
                return this.details.location.name;
            }
        },
        address() {
            if (this.eventLocation && this.eventLocation.address) {
                return this.eventLocation.address;
            } else {
                return this.details.location.address;
            }
        },
        room() {
            if (this.eventLocation && this.eventLocation.room) {
                return this.eventLocation.room;
            } else {
                return this.details.location.room;
            }
        }
    },
    filters: {
        toDateString(date) {
            let d = new Date(date.replace(' ', 'T'));
            let momentDate = moment(d).subtract(d.getTimezoneOffset()*60, 'seconds');
            return momentDate.format('dddd, MMMM D') + ' at ' + momentDate.format('h:mm a');
        }
    },
    components: {
        ServiceRow,
        EventRow
    },
  };
</script>
<style>
.booking-details-right li {
    position: relative;
    padding-left:24px;
}
.booking-details-right li.list-location {
    padding-left: 0;
}
.table-padding td {
    padding: 12px;
    padding-top: 0;
}
.table-padding tr:first-child td {
    padding-left:0;
}
.booking-details-right > ul > li {
    margin-bottom:10px;
}
img.icon {
    float: left;
    height: 18px;
    width: 18px;
    margin-left:-24px;
}
</style>
